import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type Category } from "./entity";

export const CategoryEntityConfig: HyperEntityConfig<Category> = {
  allowApiRead: true,
  allowApiCrud: [
    Roles.Admin,
    Roles.SuperAdmin,
    Roles.SuperDuperAdmin,
    Roles.Manager,
  ],
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    // SuperDuper needs marketplace category visibility (CategoryVisibilityPage).
    filter(Roles.SuperDuperAdmin, true);

    filter([Roles.Admin, Roles.SuperAdmin, Roles.Manager], {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.User, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmins, {
      organization: {
        $id: remult.user?.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);

    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user?.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },
};
